import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';

import { TeemappTableComponent } from '@teem/shared-component/teemapp-table/teemapp-table.component';
import { ACTIONS as QUOTATION_ACTIONS } from '@teem/constants/quotes';
import { SharedDataService } from '@teem/services/shared-data.service';
import { QuotationService } from '@teem/services/quotation.service';
import { UserCurrencyPipe } from '@teem/pipes/user-currency.pipe';
import { LoaderService } from '@teem/services/loader.service';
import { ngDebounce } from '@teem/decorators/debouce.decorator';
import { environment } from '@teem/environments/environment';
import { messages as i18n } from '@teem/constants/messages';
import { PLAN_TYPES } from '@teem/constants/subscription';
import { Quotation } from '@teem/models/quotation';

import QuotesTableSchema from '@teem/quotes-module/classes/quotes-table-schema';
import DraftsTableSchema from '@teem/quotes-module/classes/drafts-table-schema';

declare var $;

@Component({
  selector: 'app-quotes',
  templateUrl: './quotes.component.html',
  styles: [],
  providers: [UserCurrencyPipe]
})
export class QuotesComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @ViewChild('quotesTableRef') quotesTableRef: TeemappTableComponent;
  @ViewChild('draftsTableRef') draftsTableRef: TeemappTableComponent;

  activeTab: string = 'all-quotes';
  previousTab: string = 'all-quotes';
  quotesCount: number = 0;
  draftsCount: number = 0;
  isSearch: boolean = false;
  activeQuotation: any;
  routeSubscriber: any;
  isQuoteSelected: boolean = false;
  isDraftSelected: boolean = false;
  userInfo: any;
  isFilter: boolean = false;
  fromDate: any = '';
  toDate: any = '';
  minAmount: any;
  maxAmount: any;
  quotation_status: any = '';
  params: any = {};
  isTaxInvoice: boolean = false;
  taxIncludesValues: any = 2;

  // Quotes table variables
  quotesTable: QuotesTableSchema = new QuotesTableSchema(this);
  quotesMenuItems: Array<any> = [
    { key: "mark_as_sent", label: $localize`:@@ts.mark_as_sent:Mark as Sent`, onClick: this.markAsSent.bind(this) },
    { key: "mark_as_approved", label: $localize`:@@ts.mark_as_approved:Mark as Approved`, onClick: this.markAsApproved.bind(this) },
    { key: "mark_as_rejected", label: $localize`:@@ts.mark_as_rejected:Mark as Rejected`, onClick: this.markAsRejected.bind(this) },
    { key: "view_quotation", label: $localize`:@@ts.print_quotations:View Quotation`, onClick: this.viewQuotation.bind(this), singleOnly: true },
    { key: "email_quotations", label: $localize`:@@ts.email_quotations:Email Quotations`, onClick: this.emailQuotations.bind(this) },
    { key: "whatsapp", label: $localize`:@@ts.whatsapp_quotes:Whatsapp Quotations`, onClick: this.whatsappQuotations.bind(this), visible: false },
    { key: "delete_quotations", label: $localize`:@@ts.delete_quotations:Delete Quotations`, onClick: this.deleteQuotations.bind(this) },
    { key: "convert_to_invoice", label: $localize`:@@ts.convert_to_invoice:Convert to Invoice`, onClick: this.convertToInvoice.bind(this) }
  ];

  // Drafts table variables
  draftsTable: DraftsTableSchema = new DraftsTableSchema(this);
  draftMenuItems: Array<any> = [
    { key: "view_quotation", label: $localize`:@@ts.print_quotations:View Quotation`, onClick: this.viewQuotation.bind(this), singleOnly: true },
    { key: "save_quotations", label: $localize`:@@ts.save_quotations:Save As Quotation`, onClick: this.convertToQuotation.bind(this) },
    { key: "delete_quotation", label: $localize`:@@ts.delete_quotations:Delete Quotation`, onClick: this.deleteQuotations.bind(this) },
  ];

  constructor(
    private loaderService: LoaderService,
    private quotationService: QuotationService,
    private route: ActivatedRoute,
    private currencyPipe: UserCurrencyPipe,
    private router: Router,
    private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.routeSubscriber = this.route
      .queryParams
      .subscribe(params => {
        // Defaults to 0 if no query param provided.
        if (params && params['create-quote']) {
          this.activeTab = "create-quote";
        }
      });

    // Show/Hide whatsapp action as per pro plan
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.userInfo = data.userInfo;

        let whatsAppInvoice: any = this.quotesMenuItems.find(menu => menu.key == "whatsapp");
        whatsAppInvoice.visible = data.userInfo && data.userInfo.subscription && data.userInfo.subscription.subscription_plan == PLAN_TYPES.pro;
      }
    })
  }

  toggleFilter() {
    this.isFilter = !this.isFilter;
    this.params = {};
    this.resetDateFilters();
    this.resetAmountFilters();
    this.resetStatusFilters();
    this.quotation_status = '';
    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    }, 100);

  }

  filterByDate() {
    if (this.fromDate) {
      this.params.from_date = this.fromDate;
    }
    if (this.toDate) {
      this.params.to_date = this.toDate;
    }

    if (!(this.params.from_date || this.params.to_date)) {
      // On clear button click - Because we can't reset date filter individually for each table so here reload all tables when clear btn clicked. 
      this.quotesTableRef.resetDateFilters();
      this.draftsTableRef.resetDateFilters();

      this.quotesTableRef.getPage(1);
      this.draftsTableRef.getPage(1);
    } else if (this.params.from_date && this.params.to_date) {
      if (this.activeTab == 'all-quotes') {
        this.quotesTableRef.getPage(1, false, this.params);
      } else if (this.activeTab == 'drafts') {
        this.draftsTableRef.getPage(1, false, this.params);
      }
    }
  }

  // function called after 2s
  @ngDebounce(500)
  filterByAmount() {
    // if(this.minAmount) {
    this.params.min_amount = (this.minAmount && this.minAmount != undefined) ? this.minAmount : '';
    // }

    // if(this.maxAmount) {
    this.params.max_amount = (this.maxAmount && this.maxAmount != undefined) ? this.maxAmount : '';
    // }

    // if (this.params.min_amount || this.params.max_amount) {
    if (this.activeTab == 'all-quotes') {
      this.quotesTableRef.getPage(1, false, this.params);
    } else if (this.activeTab == 'drafts') {
      this.draftsTableRef.getPage(1, false, this.params);
    }
    // }
  }

  filterByStatus() {
    // if(this.quotation_status) {
    this.params.quotation_status = this.quotation_status;
    // }

    // if (this.params.quotation_status) {
    if (this.activeTab == 'all-quotes') {
      this.quotesTableRef.getPage(1, false, this.params);
    } else if (this.activeTab == 'drafts') {
      this.draftsTableRef.getPage(1, false, this.params);
    }
    // }
  }

  resetDateFilters() {
    if (this.fromDate || this.toDate) {
      this.fromDate = "";
      this.toDate = "";
      this.filterByDate();
    }
  }

  resetAmountFilters() {
    if (this.minAmount || this.maxAmount) {
      this.minAmount = "";
      this.maxAmount = "";
      this.filterByAmount();
    }
  }

  resetStatusFilters() {
    console.log(this.quotation_status);
    if (this.quotation_status) {
      this.quotation_status = "";
      this.params.quotation_status = "";
      this.filterByAmount();
    }
  }

  quoteActions(action, quote: any) {
    switch (action) {
      case 'view':
        this.viewQuotation([quote.uuid])
        break;
      case 'delete':
        this.deleteQuotations([quote.uuid])
        break;
      case 'edit':
        this.onQuotationEdit([quote.uuid])
        break;
      case 'convert_to_invoice':
        this.convertToInvoice([quote.uuid])
        break;
    }
  }

  isProPlan() {
    return this.userInfo && this.userInfo.subscription && this.userInfo.subscription.subscription_plan == PLAN_TYPES.pro;
  }

  toggleTableMenu() {
    if (this.activeTab == 'all-quotes') {
      if (this.isQuoteSelected) {
        this.quotesTableRef.toggleMenu();
      } else {
        Swal.fire(i18n.quote.please_select_quote);
      }
    } else if (this.activeTab == 'drafts') {
      if (this.isDraftSelected) {
        this.draftsTableRef.toggleMenu();
      } else {
        Swal.fire(i18n.quote.please_select_draft);
      }
    }
  }

  onSelectQuotes(selected: Array<any>) {
    if (selected && selected.length) {
      let showMarkAsSent = false;
      let showMarkAsApproved = false;
      let showMarkAsRejected = false;
      let showConvertToInvoice = false;
      let showSentEmail = false;

      selected.forEach((item) => {
        if (!item.sent_at)
          showMarkAsSent = true;

        if (item.client_has_email)
          showSentEmail = true;

        if (!(item.status === "approved"))
          showMarkAsApproved = true;

        if (!(item.status === "rejected"))
          showMarkAsRejected = true;

        if (!item.invoice_id && item.status !== "rejected")
          showConvertToInvoice = true;
      })

      let markAsSentMenu: any = this.quotesMenuItems.find(menu => menu.key == "mark_as_sent");
      let markAsApprovedMenu: any = this.quotesMenuItems.find(menu => menu.key == "mark_as_approved");
      let markAsRejectedMenu: any = this.quotesMenuItems.find(menu => menu.key == "mark_as_rejected");
      let convertToInvoiceMenu: any = this.quotesMenuItems.find(menu => menu.key == "convert_to_invoice");
      let emailQuotations: any = this.quotesMenuItems.find(menu => menu.key == "email_quotations");

      emailQuotations.visible = showSentEmail;
      markAsSentMenu.visible = showMarkAsSent;
      markAsApprovedMenu.visible = showMarkAsApproved;
      markAsRejectedMenu.visible = showMarkAsRejected;
      convertToInvoiceMenu.visible = showConvertToInvoice;
    }

    this.isQuoteSelected = selected.length > 0;
  }

  onSelectDraft(selected: Array<any>) {
    this.isDraftSelected = selected.length > 0;
  }

  switchTab(tab: string) {
    this.previousTab = this.activeTab;
    this.activeTab = tab;

    this.quotesTableRef.reset();
    this.draftsTableRef.reset();

    if (this.route.snapshot.queryParams['create-quote']) {
      this.router.navigateByUrl('quotations');
    }
  }

  goToPreviousTab() {
    if (this.previousTab) {
      this.activeTab = this.previousTab;
    } else {
      this.activeTab = "all-quotes";
    }

    if (this.route.snapshot.queryParams['create-quote']) {
      this.router.navigateByUrl('quotations');
    }
  }

  onCreateQuotation(data?: any) {
    this.previousTab = this.activeTab = data == 'draft' ? 'drafts' : "all-quotes";

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);

    this.quotesTableRef.getPage(1);
    this.draftsTableRef.getPage(1);
  }

  onEditQuotation(data?: any) {
    this.previousTab = this.activeTab = data == 'draft' ? 'drafts' : "all-quotes";

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);

    this.quotesTableRef.getPage(1);
    this.draftsTableRef.getPage(1);
  }

  searchQuotes(term: string) {
    if (this.activeTab == 'all-quotes') {
      this.quotesTableRef.search.next(term);
    } else if (this.activeTab == 'drafts') {
      this.draftsTableRef.search.next(term);
    }
  }

  toggleSearch() {
    this.isSearch = !this.isSearch;

    if (this.isSearch) {
      this.searchInput.nativeElement.focus();
    } else {
      this.searchInput.nativeElement.value = "";
      this.searchQuotes("");
    }
  }

  onLoadQuotes(data: any) {
    this.quotesCount = data.totalItems ? data.totalItems : 0;

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);
  }

  onLoadDrafts(data: any) {
    this.draftsCount = data.totalItems ? data.totalItems : 0;

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);
  }

  convertToQuotation(selected: Array<string>) {
    this.loaderService.startLoading();

    this.quotationService.action({ 'do': QUOTATION_ACTIONS.CONVERT_TO_QUOTATION, 'ids': selected }).subscribe(data => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.done, i18n.quote.draft_converted_to_quote, 'success');
      this.quotesTableRef.getPage(1);
      this.draftsTableRef.getPage(1);

    }, err => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
    });
  }

  viewQuotation(selected: Array<string>) {
    if (selected.length === 1) {
      this.loaderService.startLoading();
      this.quotationService.get(selected[0]).subscribe((quotation: Quotation) => {
        this.activeQuotation = quotation;
        this.activeTab = "view-quote";
        this.loaderService.stopLoading();
      }, err => {
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        this.loaderService.stopLoading();
      })
    }
  }

  onQuotationEdit(selected: Array<string>) {
    if (selected.length === 1) {
      this.loaderService.startLoading();
      this.quotationService.get(selected[0]).subscribe((quotation: Quotation) => {
        this.activeQuotation = quotation;
        this.activeTab = "edit-quote";
        this.loaderService.stopLoading();
      }, err => {
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        this.loaderService.stopLoading();
      })
    }
  }

  editQuotation(quotation: Quotation) {
    this.activeQuotation = quotation;
    this.activeTab = "edit-quote";
  }

  onDeleteQuotation(quotation: Quotation) {
    this.deleteQuotations([quotation.uuid]);
  }

  doAction(obj: any) {

    switch (obj.action) {
      case "email":
        this.emailQuotations([obj.quotation.uuid]);
        break;
      case "whatsapp":
        this.whatsappQuotations([obj.quotation.uuid]);
        break;
    }
  }

  // viewQuotation(selected: Array<string>) {
  //   this.loaderService.startLoading();
  //   this.quotationService.get(selected[0]).subscribe(data => {
  //     this.loaderService.stopLoading();
  //     this.activeQuotation = data;

  //     this.activeTab = "view-quote";
  //     // this.activeTab = "edit-quote";
  //   }, err => {
  //     this.loaderService.stopLoading();
  //   })
  // }

  emailQuotations(selected: Array<string>) {
    if (selected.length) {
      this.loaderService.startLoading();

      this.quotationService.action({ 'do': QUOTATION_ACTIONS.EMAIL, 'ids': selected }).subscribe(data => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.done, i18n.email_sent, 'success');

      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  whatsappQuotations(selected: Array<string>) {
    if (selected.length) {
      this.loaderService.startLoading();

      this.quotationService.action({ 'do': QUOTATION_ACTIONS.WHATSAPP, 'ids': selected }).subscribe(data => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.done, i18n.message_sent, 'success');

      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  deleteQuotations(selected: Array<string>) {
    if (selected.length) {
      Swal.fire({
        title: i18n.are_you_sure,
        text: i18n.quote.you_want_to_delete_quotation,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
          i18n.yes,
        cancelButtonText:
          i18n.no_cancel_it
      }).then(result => {
        if (result.value) {
          this.loaderService.startLoading();

          this.quotationService.action({ 'do': QUOTATION_ACTIONS.DELETE, 'ids': selected }).subscribe(data => {
            this.loaderService.stopLoading();

            if (this.activeTab == 'all-quotes') {
              this.quotesTableRef.getPage(1);
            } else if (this.activeTab == 'drafts') {
              this.draftsTableRef.getPage(1);
            } else {
              this.activeTab = 'all-quotes';
              this.quotesTableRef.getPage(1);
              this.draftsTableRef.getPage(1);
            }

            Swal.fire(i18n.deleted, selected.length == 1 ? i18n.quote.quote_deleted : i18n.quote.quotes_deleted, 'success');

          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          });
        }
      });
    }
  }

  markAsSent(selected: Array<string>) {
    if (selected.length) {
      this.loaderService.startLoading();

      this.quotationService.action({ 'do': QUOTATION_ACTIONS.MARK_AS_SENT, 'ids': selected }).subscribe(data => {
        Swal.fire('', i18n.quote.marked_as_sent, 'success');
        this.quotesTableRef.getPage(1);

      }, err => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  markAsApproved(selected: Array<string>) {
    if (selected.length) {
      this.loaderService.startLoading();

      this.quotationService.action({ 'do': QUOTATION_ACTIONS.MARK_AS_APPROVED, 'ids': selected }).subscribe(data => {
        Swal.fire('', i18n.quote.marked_as_approved, 'success');
        this.quotesTableRef.getPage(1);

      }, err => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  markAsRejected(selected: Array<string>) {
    if (selected.length) {
      this.loaderService.startLoading();

      this.quotationService.action({ 'do': QUOTATION_ACTIONS.MARK_AS_REJECTED, 'ids': selected }).subscribe(data => {
        Swal.fire('', i18n.quote.marked_as_rejected, 'success');
        this.quotesTableRef.getPage(1);

      }, err => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  markAsViewed(selected: Array<string>) {
    if (selected.length) {
      this.loaderService.startLoading();

      this.quotationService.action({ 'do': QUOTATION_ACTIONS.MARK_AS_VIEWED, 'ids': selected }).subscribe(data => {
        Swal.fire('', i18n.quote.marked_as_viewed, 'success');
        this.quotesTableRef.getPage(1);

      }, err => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  convertToInvoice(selected: Array<string>) {
    if (selected.length) {
      this.loaderService.startLoading();

      this.quotationService.action({ 'do': QUOTATION_ACTIONS.CONVERT_TO_INVOICE, 'ids': selected }).subscribe(data => {
        Swal.fire('', i18n.quote.converted_to_invoice, 'success');
        this.quotesTableRef.getPage(1);
        this.draftsTableRef.getPage(1);

      }, err => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  quotationAction(obj: any) {
    switch (obj.action) {
      case "accept":
        this.markAsApproved([obj.uuid]);
        break;
      case "reject":
        this.markAsRejectedWithReason(obj);
        break;
      case 'convert_to_invoice':
        this.convertToInvoice(obj.uuid)
        break;
    }
    this.activeTab = 'all-quotes';
  }


  markAsRejectedWithReason(obj: any) {
    if (obj) {
      console.log(obj)
      this.loaderService.startLoading();
      this.quotationService.rejectReason({ 'uuid': obj.uuid, 'reason': obj.rejected_reason }).subscribe(data => {
        Swal.fire('', i18n.quote.marked_as_rejected, 'success');
        this.quotesTableRef.getPage(1);

      }, err => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  exportXls() {
    (window as any).open(`${environment.baseUrl}/quotations/download?from=${this.fromDate}&to=${this.toDate}&status=${this.quotation_status}`, '_self', 'location=yes');
  }

  clearAllFilter() {
    this.params = {};
    this.resetDateFilters();
    this.resetAmountFilters();
    this.resetStatusFilters();
    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    },100);
  }

}
